import http from "../../http";

const BASE = "/gateway/api/sycompany/pc/companyPointGoodsLoss";

/** 售货点报损管理（超管端：列表 / 审核，无提交） */
const pointGoodsLoss = {
    selectPage(r) {
        return http.get(`${BASE}/selectPage`, r)
    },
    selectById(r) {
        return http.get(`${BASE}/selectById`, r)
    },
    selectLossStats(r) {
        return http.get(`${BASE}/selectLossStats`, r)
    },
    selectLossStatsForAgent(r) {
        return http.get(`${BASE}/selectLossStatsForAgent`, r)
    },
    approve(r) {
        return http.payload(`${BASE}/approve`, r)
    },
    batchApprove(r) {
        return http.payload(`${BASE}/batchApprove`, r)
    },
    batchReject(r) {
        return http.payload(`${BASE}/batchReject`, r)
    },
    reject(r) {
        return http.payload(`${BASE}/reject`, r)
    },
    cancel(r) {
        return http.payload(`${BASE}/cancel`, r)
    },
}

export default pointGoodsLoss
